export interface PremiumSource {
  totalPremium?: number | null;
  singlePremium?: number | null;
  installmentsPremium?: number | null;
}

export interface ResolvedPremiums {
  annual: number;
  installmentsTotal: number;
  monthly: number;
}

export const resolvePremiums = (source?: PremiumSource | null): ResolvedPremiums => {
  const total = source?.totalPremium ?? 0;
  const annual = source?.singlePremium ?? total;
  const installmentsTotal = source?.installmentsPremium ?? total;

  return {
    annual,
    installmentsTotal,
    monthly: installmentsTotal / 12,
  };
};
